import type { BootstrapConfig } from '../api/types';
import type { BuilderStep } from '../types/models';
import type { BuilderStore } from '../state/BuilderStore';
import type { ThreeJsViewer } from '../image/ThreeJsViewer';
import { StepCollection } from '../steps/StepCollection';
import { StepBoatColor } from '../steps/StepBoatColor';
import { StepEngine } from '../steps/StepEngine';
import { StepOptions } from '../steps/StepOptions';
import { StepQuoteSummary } from '../steps/StepQuoteSummary';
import { StepDealerSelect } from '../steps/StepDealerSelect';
import { StepCustomerInfo } from '../steps/StepCustomerInfo';

/**
 * Builds the ordered list of active steps based on config flags.
 */
export class StepRegistry {
    /**
     * Returns an array of step instances that are enabled for the current config.
     */
    static build(config: BootstrapConfig, store: BuilderStore, navigateNext?: () => void, sharedCanvas?: HTMLCanvasElement | null, overlayCanvas?: HTMLCanvasElement | null, getViewer?: (() => ThreeJsViewer | null) | null): BuilderStep[] {
        // All possible steps in order
        const allSteps: BuilderStep[] = [
            new StepCollection(store, config, navigateNext ?? null),
            new StepBoatColor(store, config, sharedCanvas ?? null, overlayCanvas ?? null, getViewer ?? null),
            new StepEngine(store, config),
            new StepOptions(store, config, sharedCanvas ?? null, overlayCanvas ?? null, getViewer ?? null),
            new StepQuoteSummary(store, config),
            new StepDealerSelect(store, config),
            new StepCustomerInfo(store, config),
        ];

        // Filter to only enabled steps
        return allSteps.filter(step => step.isEnabled(config));
    }
}
